import { useState } from 'react';
import { api, ApiError } from '../lib/api';

/**
 * Anmeldung, bei Bedarf mit zweitem Faktor.
 *
 * Für Super-Admin und Saem verlangt der Server nach dem Passwort einen Code aus der
 * Authenticator-App. Ob das nötig ist, entscheidet der Server – die Oberfläche fragt nur danach,
 * wenn er es verlangt.
 */
export function Login({ onFertig }: { onFertig: () => void }) {
  const [schritt, setSchritt] = useState<'PASSWORT' | 'CODE'>('PASSWORT');
  const [username, setUsername] = useState('');
  const [passwort, setPasswort] = useState('');
  const [code, setCode] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [läuft, setLäuft] = useState(false);

  async function anmelden(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLäuft(true);
    try {
      const ergebnis = await api.login(username, passwort);
      // Das Passwort wird nicht länger als nötig im Speicher gehalten.
      setPasswort('');
      if (ergebnis.mfaRequired) setSchritt('CODE');
      else onFertig();
    } catch (err) {
      setFehler(err instanceof ApiError ? err.message : 'Die Anmeldung hat nicht geklappt.');
    } finally {
      setLäuft(false);
    }
  }

  async function codePrüfen(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLäuft(true);
    try {
      await api.verifyMfa(code);
      onFertig();
    } catch (err) {
      setFehler(err instanceof ApiError ? err.message : 'Der Code stimmt nicht.');
      setCode('');
    } finally {
      setLäuft(false);
    }
  }

  return (
    <main className="page narrow">
      <h1>Win-Challenge</h1>

      {schritt === 'PASSWORT' ? (
        <form className="stack" onSubmit={(e) => void anmelden(e)}>
          <label>
            Benutzername
            <input
              name="username"
              value={username}
              autoComplete="username"
              autoFocus
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label>
            Passwort
            <input
              name="password"
              type="password"
              value={passwort}
              autoComplete="current-password"
              onChange={(e) => setPasswort(e.target.value)}
            />
          </label>
          <button type="submit" className="primary" disabled={läuft || !username || !passwort}>
            Anmelden
          </button>
        </form>
      ) : (
        <form className="stack" onSubmit={(e) => void codePrüfen(e)}>
          <p className="muted">
            Gib den sechsstelligen Code aus deiner Authenticator-App ein. Ein Wiederherstellungscode
            funktioniert ebenfalls.
          </p>
          <label>
            Code
            <input
              name="code"
              value={code}
              inputMode="text"
              autoComplete="one-time-code"
              autoFocus
              onChange={(e) => setCode(e.target.value)}
            />
          </label>
          <button type="submit" className="primary" disabled={läuft || !code}>
            Bestätigen
          </button>
        </form>
      )}

      {fehler && <p className="notice">{fehler}</p>}
    </main>
  );
}
